/**
 * Milestone tier tokens — mirrors the server's MILESTONES table
 * (app/services/milestones.py). Colours/motifs drive MilestoneEmblem.
 */

export type MilestoneMotif =
  | 'compass'
  | 'star'
  | 'robot'
  | 'database'
  | 'shield'
  | 'neural'
  | 'gear'
  | 'crown';

export interface MilestoneTier {
  level: number;
  name: string;
  title: string;
  light: string;
  deep: string;
  motif: MilestoneMotif;
}

export const MILESTONE_TIERS: MilestoneTier[] = [
  {
    level: 0,
    name: 'AI Explorer',
    title: 'AI Explorer',
    light: '#7FE0C0',
    deep: '#0F6E56',
    motif: 'compass',
  },
  {
    level: 1,
    name: 'AI Data Contributor',
    title: 'AI Data Contributor',
    light: '#F0C893',
    deep: '#7A4A1E',
    motif: 'star',
  },
  {
    level: 2,
    name: 'AI Data Annotator',
    title: 'AI Data Annotator',
    light: '#BFE48A',
    deep: '#3B6D11',
    motif: 'robot',
  },
  {
    level: 3,
    name: 'AI Dataset Builder',
    title: 'AI Dataset Builder',
    light: '#A9D2F6',
    deep: '#185FA5',
    motif: 'database',
  },
  {
    level: 4,
    name: 'AI Dataset Associate',
    title: 'AI Dataset Associate',
    light: '#F4C0D1',
    deep: '#993556',
    motif: 'shield',
  },
  {
    level: 5,
    name: 'AI Model Trainer',
    title: 'AI Model Trainer',
    light: '#FAD98A',
    deep: '#9A6A12',
    motif: 'neural',
  },
  {
    level: 6,
    name: 'AI Training Specialist',
    title: 'AI Training Specialist',
    light: '#F6BCA6',
    deep: '#993C1D',
    motif: 'gear',
  },
  {
    level: 7,
    name: 'AI Data Curator',
    title: 'AI Data Curator',
    light: '#D6C8F7',
    deep: '#4B2E83',
    motif: 'crown',
  },
];

export const tierFor = (level: number): MilestoneTier =>
  MILESTONE_TIERS[Math.min(Math.max(level, 0), MILESTONE_TIERS.length - 1)];
